var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.2439V5.42579C0 2.4313 2.94084 0 6.56371 0H18.4375C22.0593 0 25 2.43145 25 5.42579V15.2439C21.3769 15.2439 0 15.2439 0 15.2439ZM1.25273 15.2439H0H23.7473V5.42579C23.7473 3.00318 21.3676 1.03574 18.4375 1.03574H6.56371C3.63238 1.03574 1.25273 3.00326 1.25273 5.42579V15.2439Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7473 17.0538H25V18.8417C25 22.2418 22.0592 25.0014 18.4375 25.0014H6.56371C2.94066 25.0014 0 22.2416 0 18.8417V17.0538C0 16.7287 0.279968 16.4648 0.626367 16.4648C0.971574 16.4648 1.25273 16.7287 1.25273 17.0538C1.25273 19.8036 3.63244 22.0367 6.56371 22.0367H18.4375C21.3688 22.0367 23.7473 19.8035 23.7473 17.0538Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.814 14.7095C17.1612 15.0968 17.7256 15.0968 18.0728 14.7095C18.42 14.3222 18.42 13.6927 18.0728 13.3053L13.1286 7.79151C12.7814 7.40283 12.2183 7.40283 11.8698 7.79151L6.92691 13.3067C6.5797 13.6927 6.5797 14.3222 6.92691 14.7095C7.27412 15.0968 7.83723 15.0968 8.18444 14.7095L12.4992 9.89639L16.814 14.7095Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSquare);
export default __webpack_public_path__ + "static/media/arrowUpSquare.6c10161727a2e52a08c8cef4bd99f9d6.svg";
export { ForwardRef as ReactComponent };